var _path, _circle, _circle2, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVr(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 20,
    viewBox: "0 0 38 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 5.5C3.61929 5.5 2.5 6.61929 2.5 8V12.2744C2.5 13.4894 3.57613 14.4228 4.77893 14.2509L5.82807 14.1011C8.59531 13.7057 11.4047 13.7057 14.1719 14.1011L15.2211 14.2509C16.4239 14.4228 17.5 13.4894 17.5 12.2744V10V8C17.5 6.61929 16.3807 5.5 15 5.5H10H5Z",
    stroke: "#768390"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.5,
    cy: 10.5,
    r: 1,
    stroke: "#768390"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 10.5,
    r: 1,
    stroke: "#768390"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.672 14L19.904 5.54H21.572L24.608 12.644H24.104L27.14 5.54H28.748L24.98 14H23.672ZM29.5844 14V5.54H33.2804C34.2084 5.54 34.9244 5.76 35.4284 6.2C35.9404 6.64 36.1964 7.252 36.1964 8.036C36.1964 8.556 36.0804 9 35.8484 9.368C35.6244 9.736 35.3004 10.02 34.8764 10.22C34.4524 10.412 33.9524 10.508 33.3764 10.508L33.5444 10.28H33.9524C34.2884 10.28 34.5884 10.368 34.8524 10.544C35.1164 10.72 35.3324 10.988 35.5004 11.348L36.7364 14H35.0324L33.7844 11.252C33.6724 10.972 33.5004 10.788 33.2684 10.7C33.0444 10.612 32.7724 10.568 32.4524 10.568H31.1324V14H29.5844ZM31.1324 9.428H33.0284C33.5724 9.428 33.9844 9.316 34.2644 9.092C34.5524 8.86 34.6964 8.524 34.6964 8.084C34.6964 7.644 34.5524 7.312 34.2644 7.088C33.9844 6.864 33.5724 6.752 33.0284 6.752H31.1324V9.428Z",
    fill: "#768390"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVr);
export default __webpack_public_path__ + "static/media/vr.156284cfcb281855924b6fb28e959148.svg";
export { ForwardRef as ReactComponent };